import React, { useState, useEffect } from "react";
import Iframe from 'react-iframe'
import dataProvider from "../../services/DataProvider";

import Navigation from "../../components/Navigation";

import FormExterno from "../../components/FormExterno";

const Indicadores = () => {

    const [src, setSrc] = useState([])

    useEffect(() => {

        dataProvider.getAll('WsSanEndPoints.rule?sys=SAS').then((response) => {
            console.log(response.data.linkResultado)
            if (typeof response.data.linkResultado !== 'undefined') {
                setSrc(response.data.linkResultado)

            }

        })

    }, []);

    return (
        < >
            <Navigation titulo="Indicadores" />

            <FormExterno src={src} />

        </>
    )
}

export default Indicadores;
